import { tokens } from '@welbe/web-design-system'
import styled from 'styled-components'

export const Wrapper = styled.div<{ height?: string }>`
	display: flex;
	flex-direction: column;
	height: ${({ height }) => height};
	background: white;
`

export const Header = styled.header`
	display: grid;
	align-items: center;
	justify-content: center;
	gap: 32px;
	margin-top: 50px;
`

export const TopBanner = styled.div`
	height: 24px;
	background-color: ${tokens.color_secondary};
	width: 100%;
	position: absolute;
	top: 0;
`

export const Title = styled.p`
	color: ${tokens.color_primary};
	text-align: center;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 22px;
	margin: 24px 0;

	@media (max-width: 648px) {
		margin: 0;
	}
`
